import { useState as l, useEffect as u } from "react";
import { COOKIE_MANAGEMENT_EVENT_ACTION as n, COOKIE_PERMISSION as s } from "../cookieManagementTypes.mjs";
import d from "../utils/setCookiePermissions.mjs";
import N from "../utils/shouldRenderCookieBanner.mjs";
import a from "../utils/getAcceptedLevel.mjs";
const P = ({ onCookieManagementEvent: o }) => {
  const [c, r] = l(!1);
  return u(() => {
    Promise.resolve(window.latestPolicyVersionPromise).then((e) => {
      const t = N({
        latestPolicyVersion: typeof e == "number" ? e : void 0
      });
      if (r(t), !t) {
        const i = a();
        o(n.BANNER_NOT_DISPLAYED, {
          [s.CORE_FUNCTIONALITY]: !0,
          [s.SITE_IMPROVEMENT]: i.includes(2),
          [s.ADVERTISING]: i.includes(3)
        });
      }
      o(n.BANNER_INIT);
    });
  }, [
    o
  ]), {
    shouldDisplayCookieBanner: c,
    updatePreferences: async (e) => {
      await d(e), r(!1);
    }
  };
};
export {
  P as default
};
